// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookExplorationMobile_book-exploration-mobile-container__SA2nE{
    display: none;
}

@media(max-width: 768px){
    .BookExplorationMobile_book-exploration-mobile-container__SA2nE{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        width: 100vw;
        height: max-content;
        margin-bottom: 5vh;
        /* padding-top: 5vh; */
    }

    .BookExplorationMobile_sub-container__N7q\\+c{
        width: 80vw;
        min-height: 45vh;
        height: max-content;
        /* border: 2px solid #e65439; */
        border-top: 0px;
        border-bottom: 0px;
        border-radius: 25px;
        box-shadow: 0px 7px 8px rgba(230, 84, 57, 0.2);
        padding-top: 3vh;
        display: flex;
        flex-direction: column;
    }

    .BookExplorationMobile_swipe-arrow-container__UtvPQ{
        width: 8vw;
        height: 8vw;
        margin: auto;
    }

    .BookExplorationMobile_heading__SKlDk{
        font-size: 5vw;
        margin-top: 2vh;
        text-align: center;
        width: 70vw;
        margin-left: 5vw;
        margin-bottom: 1vh;
    }

    .BookExplorationMobile_sub-heading__o93xB{
        font-size: 4vw;
        width: 70vw;
        margin-left: 5vw;
        text-align: center;
    }

    .BookExplorationMobile_current__F\\+uXZ{
        font-size: 20vw;
        margin: 0;
        display: flex;
        flex-direction: row;
        align-self: center;
        width: 50px;
        justify-content: space-between;
        margin-top: auto;
        margin-bottom: 2vh;
    }

    .BookExplorationMobile_circle__dPGg2{
        width: 2.5vw;
        height: 2.5vw;
        border-radius: 50%;
        border: 1px solid #e65439;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/BookExplorationMobile/BookExplorationMobile.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,eAAe;QACf,uBAAuB;QACvB,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,+BAA+B;QAC/B,eAAe;QACf,kBAAkB;QAClB,mBAAmB;QACnB,8CAA8C;QAC9C,gBAAgB;QAChB,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,SAAS;QACT,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,WAAW;QACX,8BAA8B;QAC9B,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,yBAAyB;IAC7B;AACJ","sourcesContent":[".book-exploration-mobile-container{\n    display: none;\n}\n\n@media(max-width: 768px){\n    .book-exploration-mobile-container{\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        justify-content: center;\n        width: 100vw;\n        height: max-content;\n        margin-bottom: 5vh;\n        /* padding-top: 5vh; */\n    }\n\n    .sub-container{\n        width: 80vw;\n        min-height: 45vh;\n        height: max-content;\n        /* border: 2px solid #e65439; */\n        border-top: 0px;\n        border-bottom: 0px;\n        border-radius: 25px;\n        box-shadow: 0px 7px 8px rgba(230, 84, 57, 0.2);\n        padding-top: 3vh;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .swipe-arrow-container{\n        width: 8vw;\n        height: 8vw;\n        margin: auto;\n    }\n\n    .heading{\n        font-size: 5vw;\n        margin-top: 2vh;\n        text-align: center;\n        width: 70vw;\n        margin-left: 5vw;\n        margin-bottom: 1vh;\n    }\n\n    .sub-heading{\n        font-size: 4vw;\n        width: 70vw;\n        margin-left: 5vw;\n        text-align: center;\n    }\n\n    .current{\n        font-size: 20vw;\n        margin: 0;\n        display: flex;\n        flex-direction: row;\n        align-self: center;\n        width: 50px;\n        justify-content: space-between;\n        margin-top: auto;\n        margin-bottom: 2vh;\n    }\n\n    .circle{\n        width: 2.5vw;\n        height: 2.5vw;\n        border-radius: 50%;\n        border: 1px solid #e65439;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"book-exploration-mobile-container": `BookExplorationMobile_book-exploration-mobile-container__SA2nE`,
	"sub-container": `BookExplorationMobile_sub-container__N7q+c`,
	"swipe-arrow-container": `BookExplorationMobile_swipe-arrow-container__UtvPQ`,
	"heading": `BookExplorationMobile_heading__SKlDk`,
	"sub-heading": `BookExplorationMobile_sub-heading__o93xB`,
	"current": `BookExplorationMobile_current__F+uXZ`,
	"circle": `BookExplorationMobile_circle__dPGg2`
};
export default ___CSS_LOADER_EXPORT___;
